import Vue from 'vue';
// import {uuid} from 'vue-uuid';
import Left from '@/components/editor/modules/editorArea/modules/editor/assets/images/left.png'
import Right from '@/components/editor/modules/editorArea/modules/editor/assets/images/right.png'

export const filterSize = (limit) => {
  let size = "";
  if (limit < 0.1 * 1024) {    //如果小于0.1KB转化成B
    size = limit.toFixed(2) + "B";
  } else if (limit < 0.1 * 1024 * 1024) {   //如果小于0.1MB转化成KB
    size = (limit / 1024).toFixed(2) + "KB";
  } else if (limit < 0.1 * 1024 * 1024 * 1024) {    //如果小于0.1GB转化成MB
    size = (limit / (1024 * 1024)).toFixed(2) + "MB";
  } else {
    size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB";
  }
  let sizestr = size + "";
  let len = sizestr.indexOf("\.");
  let dec = sizestr.substr(len + 1, 2);

  if (dec === "00") {   //当小数点后为00时 去掉小数部分
    return sizestr.substring(0, len) + sizestr.substr(len + 3, 2);
  }
  return sizestr;
};

export const getCursortPosition = (obj) => {
  let cursorIndex = 0;
  if (document.selection) {
    obj.focus();
    let range = document.selection.createRange();
    range.moveStart('character', -obj.value.length);
    cursorIndex = range.text.length;
  } else if (obj.selectionStart || obj.selectionStart === 0) {
    cursorIndex = obj.selectionStart;
  }
  return cursorIndex;
};

export const genUUID = (len, radix) => {
  let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  let uuid = [], i;
  radix = radix || chars.length;

  if (len) {
    // Compact form
    for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
  } else {
    // rfc4122, version 4 form
    let r;
    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    uuid[14] = '4';

    // Fill in random data.  At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | Math.random() * 16;
        uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r];
      }
    }
  }

  return uuid.join('');
}

//展示选择区分不同标签和形式
export const changeHTML = (row, type, editorMode, isPreMts) => {
  if (isPreMts) {
    if (type === 'target') {
      switch (editorMode) {
        case 'standard':
          let targetTags = '';
          if (row.tagTargetSent) {
            let TargetTag = (JSON.parse(row.tagTargetSent).fragments[0].atoms) || [];
            // console.log(JSON.parse(row.tagTargetSent))
            //原文Tag-所谓的纯文本
            TargetTag.map((tagItem) => {
              if ((tagItem.tagType) === 'start') {
                let Ele = `<span class="start" contenteditable="false" info="${(tagItem.atomKey) || 'info'}*${(tagItem.dataType) || 'dataType'}*${(tagItem.id) || 'id'}*${(tagItem.sort) || 'sort'}*${(tagItem.style) || 'style'}*${(tagItem.tagType) || 'tagType'}">&nbsp;${tagItem.data}&nbsp;</span>`;
                targetTags = `${Ele}`;
              } else if ((tagItem.tagType) === 'end') {
                let Ele = `<span class="end" contenteditable="false" info="${(tagItem.atomKey) || 'info'}*${(tagItem.dataType) || 'dataType'}*${(tagItem.id) || 'id'}*${(tagItem.sort) || 'sort'}*${(tagItem.style) || 'style'}*${(tagItem.tagType) || 'tagType'}">&nbsp;${tagItem.data}&nbsp;</span>`;
                targetTags = `${targetTags}${Ele}`;
              } else {
                // style="${tagItem.style}"
                let Ele = `<span class="text" info="${(tagItem.atomKey) || 'info'}*${(tagItem.dataType) || 'dataType'}*${(tagItem.id) || 'id'}*${(tagItem.sort) || 'sort'}*${(tagItem.style) || 'style'}*${(tagItem.tagType) || 'tagType'}">${tagItem.data}</span>`;
                targetTags = `${targetTags}${Ele}`;
              }
            });
          }
          return (targetTags);
        case 'mark':
          let targetTagHTMLs = '';
          if (row.tagTargetSentHtml) {
            let TargetTagHTML = (JSON.parse(row.tagTargetSentHtml).fragments[0].atoms) || [];
            //译文Tag+修改痕迹
            (TargetTagHTML).map((tagItem) => {
              if ((tagItem.tagType) === 'start') {
                let Ele = `<span contenteditable="false" info="${(tagItem.atomKey) || 'info'}*${(tagItem.dataType) || 'dataType'}*${(tagItem.id) || 'id'}*${(tagItem.sort) || 'sort'}*${(tagItem.style) || 'style'}*${(tagItem.tagType) || 'tagType'}" class="start">&nbsp;${tagItem.data}&nbsp;</span>`;
                targetTagHTMLs = `${Ele}`;
              } else if ((tagItem.tagType) === 'end') {
                let Ele = `<span contenteditable="false" info="${(tagItem.atomKey) || 'info'}*${(tagItem.dataType) || 'dataType'}*${(tagItem.id) || 'id'}*${(tagItem.sort) || 'sort'}*${(tagItem.style) || 'style'}*${(tagItem.tagType) || 'tagType'}" class="end">&nbsp;${tagItem.data}&nbsp;</span>`;
                targetTagHTMLs = `${targetTagHTMLs}${Ele}`;
              } else {
                let Ele = `<span info="${(tagItem.atomKey) || 'info'}*${(tagItem.dataType) || 'dataType'}*${(tagItem.id) || 'id'}*${(tagItem.sort) || 'sort'}*${(tagItem.style) || 'style'}*${(tagItem.tagType) || 'tagType'}" class="text">${tagItem.data}</span>`;
                targetTagHTMLs = `${targetTagHTMLs}${Ele}`;
              }
            });
          }
          return (targetTagHTMLs);
        default:
          return (row.targetSent);
      }
    } else if (type === 'source') {
      switch (editorMode) {
        case 'standard':
          let sourceTags = '';
          if (row.tagSourceSent) {
            let SourceTag = (JSON.parse(row.tagSourceSent).fragments[0].atoms) || [];
            //原文Tag-所谓的纯文本
            SourceTag.map((tagItem) => {
              if ((tagItem.tagType) === 'start') {
                let Ele = `<img class="start" src="${Left}" type="disabled"  info="${(tagItem.atomKey) || 'info'}*${(tagItem.dataType) || 'dataType'}*${(tagItem.id) || 'id'}*${(tagItem.sort) || 'sort'}*${(tagItem.style) || 'style'}*${(tagItem.tagType) || 'tagType'}"/>`;
                sourceTags = `${Ele}`;
              } else if ((tagItem.tagType) === 'end') {
                let Ele = `<img class="end" src="${Right}" type="disabled" info="${(tagItem.atomKey) || 'info'}*${(tagItem.dataType) || 'dataType'}*${(tagItem.id) || 'id'}*${(tagItem.sort) || 'sort'}*${(tagItem.style) || 'style'}*${(tagItem.tagType) || 'tagType'}"/>`;
                sourceTags = `${sourceTags}${Ele}`;
              } else {
                //style="${tagItem.style}"
                // let uuid2 = uuid.v1();
                // 导致光标失效
                let Ele = `<span class="text" info="${(tagItem.atomKey) || 'info'}*${(tagItem.dataType) || 'dataType'}*${(tagItem.id) || 'id'}*${(tagItem.sort) || 'sort'}*${(tagItem.style) || 'style'}*${(tagItem.tagType) || 'tagType'}*${genUUID()}">${tagItem.data}</span>`;
                sourceTags = `${sourceTags}${Ele}`;
              }
            });
          }


          return (sourceTags);
        case 'mark':
          return (row.sourceSent);
        default:
          return (row.sourceSent);
      }
    }
  }
};

//解析节点文本--除删除
export const getEditorText = (dom, row) => {
  let info = dom.getAttribute("info");
  let temp = {};
  if (info) {
    //代表是后端返回的数据--需要提出del数
    let innerText = '';
    if ((dom.nodeType) === 1) {
      const childNodes = (dom.childNodes);
      childNodes.forEach((item3) => {
        if ((item3.nodeType) === 1) {
          if ((item3.getAttribute('class') !== 'del')) {
            innerText = trimSpace(`${innerText}\xa0${item3.innerText}`);
            //如果插入的Tag需要在进一步判断结果
            if ((item3.getAttribute('class') === 'start')) {
              console.log('Tag左侧')
            }
            if ((item3.getAttribute('class') === 'end')) {
              console.log('Tag右侧')
            }
          }
        } else {
          innerText = trimSpace(`${innerText}\xa0${item3.data}`)
        }
      });
    } else if ((childNodes.nodeType) === 3) {
      //纯文本
      innerText = (childNodes.data)
    }
    let arr = info.split("*");
    Reflect.set(temp, 'data', innerText);
    Reflect.set(temp, 'atomKey', arr[0]);
    Reflect.set(temp, 'dataType', arr[1]);
    Reflect.set(temp, 'id', arr[2]);
    Reflect.set(temp, 'sort', arr[3]);
    Reflect.set(temp, 'style', arr[4]);
    Reflect.set(temp, 'tagType', arr[5]);
  } else {
    //编辑器生成数据-可以直接取数据-可能是定位标签
    Reflect.set(temp, 'data', trimSpace(dom.innerText));
    Reflect.set(temp, 'atomKey', (row.templateKey));
    Reflect.set(temp, 'dataType', 'text');
    Reflect.set(temp, 'id', row.TargetTag[0].id);
    Reflect.set(temp, 'sort', row.TargetTag[0].sort);
    Reflect.set(temp, 'style', row.TargetTag[0].style);
    Reflect.set(temp, 'tagType', 'text');
  }
  return temp
};

//去除左右空格
export const trimSpace = (str) => {
  return str.replace(/(^\s*)|(\s*$)/g, "");
};

//替换指定文字
// export const highlight = (keyWords, resultsList, item, type) => {
//   // console.log(item);
//   let params = Object();
//   if (!!resultsList) {
//     // console.log( resultsList.toString().replace(/<[^>]+>/g,""))
//     let resultsLists = resultsList.toString().replace(/<[^>]+>/g, "");
//     // console.log(resultsLists)
//     if (keyWords && keyWords.length > 0) {
//       // 匹配关键字正则
//       let replaceReg = new RegExp(keyWords, 'gi');
//       // 高亮替换v-html值
//       if (resultsList.search(keyWords) !== -1) {
//         let temp = { ...item };
//         Reflect.set(temp, 'type', type);
//         Reflect.set(params, 'item', temp);
//       }
//       let replaceString = `<span class="hightLight">${keyWords}</span>`;
//       resultsList = resultsLists.replace(replaceReg, replaceString);
//     }
//     Reflect.set(params, 'resultsList', resultsList);
//   }
//   return params
// };

export const highlight = (keyWords, resultsList, item, type) => {
  let params = Object();
  if (resultsList) {
    let resultsLists = resultsList.toString().replace(/<[^>]+>/g, "");
    if (keyWords && keyWords.length > 0) {
      // 匹配关键字正则，不区分大小写
      let replaceReg = new RegExp(keyWords, 'gi');
      // 高亮匹配的字符
      resultsList = resultsLists.replace(replaceReg, match => `<span class="hightLight">${match}</span>`);
      if (resultsList.search(replaceReg) !== -1) {
        let temp = { ...item };
        Reflect.set(temp, 'type', type);
        Reflect.set(params, 'item', temp);
      }
    }
    Reflect.set(params, 'resultsList', resultsList);
  }
  return params;
};

export const childNodes2 = (dom) => {
  let str2;
  dom.forEach((item) => {
    if ((item.nodeType) === 1) {
      let dom2 = Array.from((item.childNodes));
      childNodes2(dom2);
    } else if ((item.nodeType) === 3) {
      let str = (item.data).replace(/(^\s*)|(\s*$)|[\r\n]/g, '');
      if (str) {
        console.log(str)
      }
    }
    return (str2)
  });
};

export const childNodes3 = (dom, value) => {
  dom.forEach((item) => {
    if ((item.nodeType) === 1) {
      let dom2 = Array.from((item.childNodes));
      childNodes3(dom2);
    } else if ((item.nodeType) === 3) {
      return highlight(value, (item.data));
    }
  })
};

export const childNodes = (dom) => {
  dom.forEach((item) => {
    let tempNode = document.createElement("div");
    tempNode.appendChild(item.cloneNode(true));
    let string = tempNode.innerHTML;
    tempNode = node = null;
    return string;
  });
};

//对象便利成节点
export const createNodes = (dom) => {
  let targetTags = '';
  let dom2 = (JSON.parse(dom).fragments[0].atoms) || [];
  dom2.map((tagItem) => {
    if ((tagItem.tagType) === 'start') {
      let Ele = `<span class="start" contenteditable="false" info="${(tagItem.atomKey) || 'info'}*${(tagItem.dataType) || 'dataType'}*${(tagItem.id) || 'id'}*${(tagItem.sort) || 'sort'}*${(tagItem.style) || 'style'}*${(tagItem.tagType) || 'tagType'}">&nbsp;${tagItem.data}&nbsp;</span>`;
      targetTags = `${Ele}`;
    } else if ((tagItem.tagType) === 'end') {
      let Ele = `<span class="end" contenteditable="false" info="${(tagItem.atomKey) || 'info'}*${(tagItem.dataType) || 'dataType'}*${(tagItem.id) || 'id'}*${(tagItem.sort) || 'sort'}*${(tagItem.style) || 'style'}*${(tagItem.tagType) || 'tagType'}">&nbsp;${tagItem.data}&nbsp;</span>`;
      targetTags = `${targetTags}${Ele}`;
    } else {
      let Ele = `<span class="text" info="${(tagItem.atomKey) || 'info'}*${(tagItem.dataType) || 'dataType'}*${(tagItem.id) || 'id'}*${(tagItem.sort) || 'sort'}*${(tagItem.style) || 'style'}*${(tagItem.tagType) || 'tagType'}">${tagItem.data}</span>`;
      targetTags = `${targetTags}${Ele}`;
    }
  });
  return targetTags
};

//对象便利成节点
export const createNodes2 = (dom) => {
  let HTML = '';
  if (dom.length) {
    dom.forEach((item) => {
      if ((item.tagType) === 'start') {
        let Ele = `<span class="start" contenteditable="false" info="${(item.atomKey) || 'info'}*${(item.dataType) || 'dataType'}*${(item.id) || 'id'}*${(item.sort) || 'sort'}*${(item.style) || 'style'}*${(item.tagType) || 'tagType'}">&nbsp;${item.data}&nbsp;</span>`;
        HTML = `${Ele}`;
      } else if ((item.tagType) === 'end') {
        let Ele = `<span class="end" contenteditable="false" info="${(item.atomKey) || 'info'}*${(item.dataType) || 'dataType'}*${(item.id) || 'id'}*${(item.sort) || 'sort'}*${(item.style) || 'style'}*${(item.tagType) || 'tagType'}">&nbsp;${item.data}&nbsp;</span>`;
        HTML = `${HTML}${Ele}`;
      } else {
        let Ele = `<span class="text" info="${(item.atomKey) || 'info'}*${(item.dataType) || 'dataType'}*${(item.id) || 'id'}*${(item.sort) || 'sort'}*${(item.style) || 'style'}*${(item.tagType) || 'tagType'}">${item.data}</span>`;
        HTML = `${HTML}${Ele}`;
      }
    })
  }
  return HTML
};

// 滚动事件-触底加载分页数据
export const elementScroll = (e) => {
  //变量scrollTop是滚动条滚动时，距离顶部的距离
  let scrollTop = e.target.scrollTop;
  //变量windowHeight是可视区的高度
  let windowHeight = e.target.clientHeight;
  //变量scrollHeight是滚动条的总高度
  let scrollHeight = e.target.scrollHeight;
  //滚动条到底部的条件
  return ((scrollTop + windowHeight) === scrollHeight);
};

// 规整DOM节点成数组
export const domArray = (obj, row, Array2, filterDel) => {
  obj.forEach((item, index) => {
    if (filterDel === 'filterDel' && item.className && item.className.includes('del')) {
      // filterDel 过滤 del
    } else {
      let params = {};
      if ((item.nodeType) === 1) {
        let childNodes2 = Array.from((item.childNodes));
        if (((item.nodeName).toLowerCase()) === 'img') {
          let findInfo2 = item.getAttribute('info').split("*");
          Reflect.set(params, 'atomKey', findInfo2[0]);
          Reflect.set(params, 'dataType', findInfo2[1]);
          Reflect.set(params, 'id', findInfo2[2]);
          Reflect.set(params, 'sort', findInfo2[3]);
          Reflect.set(params, 'style', findInfo2[4]);
          Reflect.set(params, 'tagType', findInfo2[5]);
          Reflect.set(params, 'data', findInfo2[7]);
          Array2.push(params)
        }
        return domArray(childNodes2, row, Array2, filterDel)
      } else if ((item.nodeType) === 3) {
        // let str = (item.data).replace(/(^\s*)|(\s*$)|[\r\n]/g, '');
        let str = (item.data);
        let parentNode2 = (item.parentNode);
        if (str) {
          if (parentNode2) {
            let findInfo2 = findInfo(parentNode2).split("*");
            //编辑器生成数据-可以直接取数据-可能是定位标签
            Reflect.set(params, 'data', filterDel === 'leaveMarkModel' ? (item.parentNode.outerHTML) : (item.data));
            Reflect.set(params, 'atomKey', (findInfo2[0]));
            Reflect.set(params, 'dataType', findInfo2[1]);
            Reflect.set(params, 'id', findInfo2[2]);
            Reflect.set(params, 'sort', findInfo2[3]);
            Reflect.set(params, 'style', findInfo2[4]);
            Reflect.set(params, 'tagType', findInfo2[5]);
            Array2.push(params)
          } else {
            Reflect.set(params, 'atomKey', (row.templateKey));
            Reflect.set(params, 'dataType', 'text');
            Reflect.set(params, 'data', filterDel === 'leaveMarkModel' ? (item.parentNode.outerHTML) : (item.data));
            Reflect.set(params, 'id', (row.id));
            Reflect.set(params, 'sort', `${parseInt((row.id).toString().substr(0, 5))}`);
            Reflect.set(params, 'style', null);
            Reflect.set(params, 'tagType', 'text');
            Array2.push(params)
          }
        } else {
          let findInfo2 = findInfo(parentNode2).split("*");
          console.log(findInfo2)
        }
      }
    }
  });
  return Array2
};

//查找父级别的自定义属性
export const findInfo = (item) => {
  if (!(item.getAttribute('type'))) {
    let info = (item.getAttribute('info'));
    if (info) {
      return info
    } else {
      let item2 = (item.parentNode);
      return findInfo(item2)
    }
  } else {
    return ''
  }
};


//查找父级别的自定义属性
export const findID = (item) => {
  if (item) {
    if (item.getAttribute('id')) {
      let info = (item.getAttribute('id'));
      let fragmentindex = (item.getAttribute('fragmentindex'));
      let infoArr = info.split('-');
      if (fragmentindex) {
        infoArr.push(fragmentindex)
      }
      return infoArr;
    } else {
      let parentItem = (item.parentNode);
      return findID(parentItem)
    }
  } else {
    return Array()
  }
};


//获取对象下的节点
export const setTextNode = function (ele, children) {
  let childNodes = ele.childNodes;
  let info = ele.getAttribute('info').split('*');
  if ((childNodes)) {
    for (let i = 0; i < childNodes.length; i++) {
      const element = childNodes[i];
      if (element.childNodes.length > 1) {
        setTextNode(children, element)
      } else if (element.nodeType === 3) {
        let node = element;
        let len = children.length ? children[children.length - 1].end : 0;
        children.push({ node, start: len, end: (node.length + len), info: info })
      } else if (element.firstChild && element.firstChild.nodeType === 3) {
        let node = element.firstChild;
        let len = children.length ? children[children.length - 1].end : 0;
        children.push({ node, start: len, end: (node.length + len), info: info })
      } else {
        setTextNode(children, element)
      }
    }
  }
  return children
};

// 规整DOM节点成数组
export const domArray2 = (obj, Array2, completeStr) => {
  obj.forEach((item) => {
    let params = {};
    if ((item.nodeType) === 1) {
      let childNodes2 = Array.from((item.childNodes));
      if (((item.nodeName).toLowerCase()) === 'img') {
        let findInfo2 = item.getAttribute('info').split("*");
        Reflect.set(params, 'atomKey', findInfo2[0]);
        Reflect.set(params, 'dataType', findInfo2[1]);
        Reflect.set(params, 'id', findInfo2[2]);
        Reflect.set(params, 'sort', findInfo2[3]);
        Reflect.set(params, 'style', '');
        Reflect.set(params, 'data', findInfo2[7]);
        Reflect.set(params, 'tagType', findInfo2[5]);
        Reflect.set(params, 'fid', findInfo2[6]);
        Array2.push(params)
      }
      return domArray2(childNodes2, Array2)
    } else if ((item.nodeType) === 3) {
      let str2 = (item.data).replace(/(^\s*)|(\s*$)|[\r\n]/g, '');
      let str = (item.data);
      if (str) {
        let parentNode2 = (item.parentNode);
        if (parentNode2.length) {
          let findInfo2 = findInfo(parentNode2).split("*");
          //编辑器生成数据-可以直接取数据-可能是定位标签
          Reflect.set(params, 'data', str);
          Reflect.set(params, 'atomKey', (findInfo2[0]));
          Reflect.set(params, 'dataType', findInfo2[1]);
          Reflect.set(params, 'id', findInfo2[2]);
          Reflect.set(params, 'sort', findInfo2[3]);
          Reflect.set(params, 'style', findInfo2[4]);
          Reflect.set(params, 'tagType', findInfo2[5]);
          Reflect.set(params, 'fid', findInfo2[6]);
          Array2.push(params);
        } else {
          let findInfo2 = findInfo(parentNode2).split("*");
          Reflect.set(params, 'atomKey', findInfo2[0]);
          Reflect.set(params, 'dataType', 'text');
          Reflect.set(params, 'data', str);
          Reflect.set(params, 'id', findInfo2[2]);
          Reflect.set(params, 'sort', findInfo2[3]);
          Reflect.set(params, 'style', findInfo2[4]);
          Reflect.set(params, 'tagType', 'text');
          Reflect.set(params, 'fid', findInfo2[6]);
          Array2.push(params);
        }
      }
    }
  });
  return Array2
};

//获取Cookie
export const getCookie = (name) => {
  let arr;
  let reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg)) {
    return unescape(arr[2]);
  } else {
    return null;
  }
};

//清除
export const clearCookieByKey = (key) => {
  setCookie(key, "", -1);
};

//获取所有
export const getAllCookies = () => {
  let cookies = document.cookie.split(/;\s/g);
  let cookieObj = {};
  cookies.forEach(function (item) {
    let key = item.split('=')[0];
    cookieObj[key] = item.split('=')[1];
  });
  return cookieObj;
};

//清除所有
export const clearCookies = () => {
  let keys = Object.keys(getAllCookies());
  keys.forEach(function (item) {
    clearCookieByKey(item);
  });
};

export const isSame = (arg1, arg2) => {
  let bol = true;
  if (Object.keys(arg1).length !== Object.keys(arg2).length) {
    return false;
  }
  for (let key in arg1) {
    if (typeof arg1[key] === 'object') {
      bol = isSame(arg1[key], arg2[key]);
      if (!bol) {
        break;
      }
    } else if (arg1[key] !== arg2[key]) {
      bol = false;
      break;
    }
  }
  return bol
};

export const parseJSONSafely = (str) => {
  try {
    return JSON.parse(str);
  } catch (e) {
    console.err(e);
    return {}
  }
};

//判断tag数据格式是否是null
export const tagDataIsEmpty = (obj) => {
  let bool = false;
  if (!!obj && !!(obj.fragments) && !!(obj.fragments.length)) {
    let firstFragments = (obj.fragments)[0];
    if (!!firstFragments && !!(firstFragments.atoms) && (firstFragments.atoms.length)) {
      let atoms = (firstFragments.atoms);
      atoms.every((item) => {
        if (Reflect.has(item, 'data') && (!!(item.data))) {
          bool = true
        }
      });
    }
  }
  return bool
};

export const preventReClick = Vue.directive('preventReClick', {
  inserted: function (el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true;
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 3000)
      }
    })
  }
});

export const setCursorEnd = (el) => {
  // 创建一个范围对象
  let range = document.createRange();
  range.selectNodeContents(el);
  range.collapse(false);

  if (navigator.userAgent.indexOf("Firefox") >= 0) {
    // 在Firefox中使用textarea或input元素的setSelectionRange()方法
    if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) {
      el.setSelectionRange(el.value.length, el.value.length);
    } else {
      // 在其他contenteditable元素中使用range对象
      let selection = el.ownerDocument.defaultView.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
    }
  } else {
    // 在其他浏览器中使用range对象
    let selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
  }
  // 将焦点放在元素上
  el.focus();
};
//获取光标的位置
export const getDivPosition = (element) => {
  let caretOffset = 0;
  let doc = element.ownerDocument || element.document;
  let win = doc.defaultView || doc.parentWindow;
  let sel;
  if (typeof win.getSelection !== "undefined") {
    //谷歌、火狐
    sel = win.getSelection();
    if (sel.rangeCount > 0) {
      //选中的区域
      let range = win.getSelection().getRangeAt(0);
      let preCaretRange = range.cloneRange(); //克隆一个选中区域
      preCaretRange.selectNodeContents(element); //设置选中区域的节点内容为当前节点
      preCaretRange.setEnd(range.endContainer, range.endOffset); //重置选中区域的结束位置
      caretOffset = preCaretRange.toString().length;
    }
  } else if ((sel = doc.selection) && sel.type !== "Control") {
    let textRange = sel.createRange();
    let preCaretTextRange = doc.body.createTextRange();
    preCaretTextRange.moveToElementText(element);
    preCaretTextRange.setEndPoint("EndToEnd", textRange);
    caretOffset = preCaretTextRange.text.length;
  }
  return caretOffset;
};

//设置光标位置函数
export const setCaretPosition = (element, Position) => {
  if (element.setSelectionRange) {
    element.focus();
    element.setSelectionRange(Position, Position);
  } else if (element.createTextRange) {
    let range = element.createTextRange();
    range.collapse(true);
    range.moveEnd('character', Position);
    range.moveStart('character', Position);
    range.select();
  }
};

//保存光标位置
export const saveSelection = () => {
  if (window.getSelection) {
    let sel = window.getSelection();
    if (sel.getRangeAt && sel.rangeCount) {
      return sel.getRangeAt(0);
    }
  } else if (document.selection && document.selection.createRange) {
    return document.selection.createRange();
  }
  return null;
};

//设置光标位置
export const restoreSelection = (range) => {
  if (range) {
    if (window.getSelection) {
      let sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    } else if (document.selection && range.select) {
      range.select();
    }
  } else {
    return false
  }
};


// 编辑器锁定状态
// export const lockState = (item) => {
//   let urlInfo = this.$store.getters['editor/getUrlInfo'];
//   //可读可写的状态 - 1/0
//   let content = this.$store.getters['editor/getTaskContentList'];
//   // ifOnlyPreview 是否可编辑：0.不是 1.是
//   let ifOnlyPreview = !(parseInt(content.ifOnlyPreview) === 1);
//   //项目内重复- sameProjectSentNo > 0 锁定/不锁定
//   let projectSome = (parseInt(item.sameProjectSentNo) === 0);
//   //文件内重复- sameFileSentNo > 0    锁定/不锁定
//   let fileSome = (parseInt(item.sameFileSentNo) === 0);
//   if ((urlInfo.type) === 'project') {
//     //是否被拆分 0/1 - (未分配/分配) - (能编辑/编辑)
//     let fileInfo = this.$store.getters['editor/getFileInfo'];
//     let isSplit = !(!!parseInt(fileInfo.isSplit));
//     return (isSplit && ifOnlyPreview && projectSome && fileSome);
//   } else if ((urlInfo.type) === 'task') {
//     let fileTaskInfo = this.$store.getters['editor/getFileTaskInfo'];
//     let isFinish = (parseInt(fileTaskInfo.finish) !== 1);
//     return (isFinish && ifOnlyPreview && projectSome && fileSome);
//   }
// };